var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('app-header',{on:{"on-search":_vm.onTextSearch}}),_vm._v(" "),_c('div',{staticClass:"page",attrs:{"id":"pageScrollContainer"}},[_c('nuxt',{staticClass:"page__main"}),_vm._v(" "),_c('app-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }